import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AauditTrailEmployee } from '../entities/aaudit-trail-employee';
import { TimesheetRoutingModule } from 'app/modules/mutual/timesheet/timesheet-routing.module';

@Injectable()
export class AauditTrailEmployeeService extends BaseCrudService<AauditTrailEmployee> {

  public uri = '/api/aauditTrailEmployee/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance AauditTrailEmployeeService');
  }

  buildSentence(entity?: AauditTrailEmployee, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.id ?
          `id${QueryOperator.Contain}${entity.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.tableId ?
          `tableId${QueryOperator.Equal}${entity.tableId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.operationTypeId ?
          `operationTypeId${QueryOperator.Equal}${entity.operationTypeId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.operationDate ?
          `operationDate${QueryOperator.Equal}${entity.operationDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.aauditJson ?
          `aauditJson${QueryOperator.Equal}${entity.aauditJson}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.employeeId ?
          `employeeId${QueryOperator.Equal}${entity.employeeId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.childEntityId ?
          `childEntityId${QueryOperator.Equal}${entity.childEntityId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.user && entity.user.id) {
        query = query.concat(
          `user.id${QueryOperator.Equal}${entity.user.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/aaudit-trail-employee.service.ts